import Login from '@/components/login/index.vue'
import Exames from '@/components/exames/index.vue'
import ExamesPdf from '@/components/exames/pdf/index.vue'
import BuscaCpf from '@/components/exames-cpf/index.vue'
import Admin from '@/components/admin/index.vue'
import MedicoLaudar from '@/components/medico/index.vue'
import MedicoValidate from '@/components/medico-validate/index.vue'
import RadioReport from '@/components/medico/radioReport/index.vue'
import RevisarLaudo from '@/components/medico/revisarLaudo/index.vue'
import DicomPlus from '@/components/dicom-plus/index.vue'
import TracadoPlus from '@/components/x-plus/index.vue'

import i18n from '@/i18n'

const routes = [
  {
    path: '/',
    component: Login,
    name: 'login',
    meta: { requiresAuth: false }
  },
  {
    path: '/exames',
    component: Exames,
    meta: { requiresauth: true, requireredirect: true, roles: ['source'] },
    name: 'exames',
    menu: {
      name: i18n.tc('Exames')
    }
  },
  {
    path: '/exames/pdf',
    component: ExamesPdf,
    meta: { requiresauth: true, requireredirect: true, roles: ['source', 'physician', 'analyst'] },
    name: 'examesPdf',
    props: (route) => {
      return {
        id: route.query.id,
        isLaudo: route.query.isLaudo,
        pdfUrl: route.query.pdfUrl
      }
    }
  },
  {
    path: '/medico',
    name: 'medicoHome',
    meta: { requiresAuth: true, requireRedirect: true, roles: ['physician'], needsManagerPhysician: true },
    menu: {
      name: 'Home'
    }
  },

  {
    path: '/busca-por-cpf',
    component: BuscaCpf,
    meta: { requiresauth: true, requireredirect: true, roles: ['source'] },
    name: 'busca-por-cpf'
  },
  {
    path: '/medico/laudar-radio',
    name: 'laudarRadio',
    component: RadioReport,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['physician']},
    menu: {
      name: i18n.t('radio_report.report_radio')
    }
  },
  {
    path: '/medico/revisar-laudo',
    name: 'revisarLaudo',
    component: RevisarLaudo,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['physician']},
    menu: {
      name: i18n.t('radio_report.review_report')
    }
  },
  {
    path: '/medico/laudar',
    name: 'medicoLaudar',
    component: MedicoLaudar,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['physician']  },
    menu: {
      name: i18n.t('to_report')
    }
  },
  {
    path: '/medico/validate',
    name: 'medicoValidate',
    component: MedicoValidate,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['physician'], }
  },
  {
    path: '/analista',
    name: 'analista',
    component: MedicoLaudar,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['analyst', 'physician'] }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['admin', 'adminPhysician'] },
    beforeEnter: (to, from, next) => {
      window.location = `${window.location.origin}/admin/exames`
    }
  },
  {
    path: '/users',
    name: 'adminSource',
    component: Admin,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['adminSource'] },
    beforeEnter: (to, from, next) => {
      window.location = `${window.location.origin}/admin/users`
    }
  },
  {
    path: '/dicomplus',
    name: 'dicom-plus',
    component: DicomPlus,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['admin', 'source', 'adminSource'] },
    menu: {
      name: i18n.tc('Dicom Plus')
    }
  },
  {
    path: '/tracadoplus',
    name: 'tracado-plus',
    component: TracadoPlus,
    meta: { requiresAuth: true, requireRedirect: true, roles: ['admin', 'source', 'adminSource'] },
    menu: {
      name: `${i18n.tc('tracing')} Plus`
    }
  }
]

export default routes
